module.exports = __webpack_public_path__ + "assets/img/1.a41f35c4.png";